import {type ReactNode} from 'react';

import Tooltip from '@mui/material/Tooltip';

import {OptixButton, type OptixButtonProps} from '../../../../button';
import {OptixIconButton} from '../../../../button';
import {useOptixTableContext} from '../../../OptixTableContext';

interface OptixTableActionsButtonProps {
  text: string;
  icon: ReactNode;
  loading?: boolean;
  loadingText?: string;
  onClick: OptixButtonProps['onClick'];
  iconOnly?: boolean;
}

export function OptixTableActionsButton({
  text,
  icon,
  loading = false,
  loadingText,
  onClick,
  iconOnly = false,
}: OptixTableActionsButtonProps): JSX.Element {
  const {loading: loadingTable} = useOptixTableContext();

  if (iconOnly && icon != null) {
    return (
      <Tooltip title={text}>
        <span>
          <OptixIconButton
            size="small"
            color="inherit"
            disabled={loadingTable}
            onClick={onClick}
          >
            {icon}
          </OptixIconButton>
        </span>
      </Tooltip>
    );
  }

  return (
    <OptixButton
      text={text}
      startIcon={icon}
      onClick={onClick}
      disabled={loadingTable}
      loading={loading}
      loadingText={loadingText}
      color="inherit"
      variant="text"
      size="small"
    />
  );
}
